import Image from 'core/display/Image'
import { enableTap } from 'core/handlers/TapHandler'
import { ButtonManager } from 'managers/ButtonManager'
import { KeyboardManager } from 'managers/KeyboardManager'
import { signal } from 'services/SignalsService'

export default class RadioButton {
  constructor(data) {
    this._data = data
    this.self = new Image(data)
    this.self.calculateGlow()
    this.name = data.name.split('-')[0]
    this.payload = data.name.split('-')[1]
    this.id = `RADIO:${this.name}`
    this.state = ''

    this.createSignal()

    KeyboardManager.register({ id: this.id, payload: this.payload, tap: this.tap.bind(this) })
    enableTap(this.self, this.tap.bind(this))

    return data.name !== 'menu-history'
      ? this.self
      : new Image(data)
  }

  createSignal() {
    const self = this

    signal.on( self.id, function (value) {
      self.state = value
      self.self.images[0].visible =  self.payload !== value
      self.self.images[1].visible =  self.payload === value
    })
  }

  tap(){
    ButtonManager.dispatch(this.id, this._data.deselect && this.payload === this.state ? '' : this.payload)
  }
}
